import { ccfRoutes } from '@app/ccf/ccf-routes';
import ReportLayoutHeader from '@app/components/reports/components/report-layout-header';
import { useDownloadReportResults } from '@shared/api/hooks/ccf/results';
import { downloadCSV } from '@shared/lib/utils';
import sentry from '@shared/services/sentry';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { useCCFReportResult } from '../ccf-report-result-context';

export default function CCFReportLayoutHeader() {
  const {
    result: { reportUuid, title },
  } = useCCFReportResult();
  const [isDownloadCSV, setIsDownloadCSV] = useState(false);
  const { data, refetch } = useDownloadReportResults(reportUuid, {
    enabled: isDownloadCSV,
  });

  async function handleDownloadCSV() {
    setIsDownloadCSV(true);
    const res = await refetch();
    try {
      const CSVdata = data || res.data;
      downloadCSV(CSVdata, `${title}.csv`);
    } catch (error) {
      sentry.log(error);
    } finally {
      setIsDownloadCSV(false);
    }
  }

  const handleDownloadPDF = () => {
    const path = generatePath(ccfRoutes.REPORT_DOWNLOAD, {
      report_uuid: reportUuid,
    });
    window.open(path, '_blank');
  };

  return (
    <ReportLayoutHeader
      reportType="ccf"
      reportUuid={reportUuid}
      handleDownloadCSV={handleDownloadCSV}
      handleDownloadPDF={handleDownloadPDF}
      isDownloadCSV={isDownloadCSV}
    />
  );
}
